import { ArrowRight, MessageSquare } from "lucide-react"

import { ActionDefinition } from "@/components/automations/types"

export const opportunityActions: ActionDefinition[] = [
  {
    key: "action__opportunity_move_stage",
    name: "Move to stage",
    description: "Move the opportunity to a specific stage",
    category: "opportunity",
    nodeType: "action",
    recordType: "opportunity",
    icon: ArrowRight,
    requiresSubjects: ["opportunity"],
    fields: [
      {
        key: "pipeline_id",
        label: "Pipeline",
        inputType: "select",
        required: true,
        optionsSource: "pipelines",
      },
      {
        key: "pipeline_stage_id",
        label: "Stage",
        inputType: "select",
        required: true,
        optionsSource: "pipeline_stages",
        parentField: "pipeline_id",
      },
    ],
  },
  {
    key: "action__opportunity_add_comment",
    name: "Add comment",
    description: "Add a comment to the opportunity",
    category: "opportunity",
    nodeType: "action",
    recordType: "opportunity",
    icon: MessageSquare,
    requiresSubjects: ["opportunity"],
    fields: [
      {
        key: "content",
        label: "Comment",
        inputType: "textarea",
        required: true,
        supportsInterpolation: true,
      },
    ],
  },
]
